
export class RingPart extends Phaser.GameObjects.Image {
  
}
